import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function CheckoutCancel() {
  return (
    <>
      <Header onOpenBrief={() => {}} />
      <main className="max-w-[720px] mx-auto px-5 py-16 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[var(--sky)] mb-5">
          <XCircle className="text-[var(--muted)]" size={32} />
        </div>
        <h1 className="text-[28px] font-black tracking-[-0.02em]" data-testid="checkout-cancel-title">Checkout canceled.</h1>
        <p className="text-[15px] text-[var(--muted)] mt-3">No charge was made. Come back any time.</p>
        <div className="mt-7 flex gap-3 justify-center">
          <Link to="/" className="btn primary" data-testid="checkout-cancel-home">Back to Newseze</Link>
        </div>
      </main>
      <Footer />
    </>
  );
}
